export enum AvailableComponentTypes {
	title = 1,
	description,
	url,
	stringArray,
	json,
	htmlText,
	blockTitle,
}

export enum AvailablePageNodes {
	main_block = 'main_block',
	disclaimer_central_bank = 'disclaimer_central_bank',
	application_form_cross = 'application_form_cross',
	tabs = 'tabs',
	credit_conditions = 'credit_conditions',
	credit_repayment_methods = 'credit_repayment_methods',
	credit_about = 'credit_about',
	credit_alternative = 'credit_alternative',
	how_to_loan = 'how_to_loan',
	our_specialists = 'our_specialists',
	feedback = 'feedback',
	feedback_custom = 'feedback_custom',
	faq = 'faq',
	html_text = 'html_text',
	told_about_pledge = 'told_about_pledge',
	mobile_application = 'mobile_application',
	deal_conditions = 'deal_conditions',
	steps = 'steps',
	blocks_with_icons = 'blocks_with_icons',
	credit_order = 'credit_order',
	bonus_calculator = 'bonus_calculator',
	disclamer_main = 'disclamer_main',
	credit_rate = 'credit_rate',
	partner_form_section = 'partner-form-section',
	partner_logos = 'partner-logos',
	text_cols = 'text_cols',
	app_custom = 'app_custom',
}

interface BaseEntity {
	dateCreated: string
	id: number
}

export interface PageVariable {
	key: string
	value: string
}

export interface PageConfig extends BaseEntity {
	name: string
	url: string
	isPublished: boolean
	isRegional: false
	breadcrumbTitle: string | null
	pageNode: PageNode[]
	pageMeta: PageMeta[]
	variables: PageVariable[]
}

export enum PageMetaType {
	Title = 1,
	Description = 2,
	OgTitle = 3,
	OgDesc = 4,
	OgImageSource = 5,
	CanonicalLink = 6,
}

export interface PageMeta extends BaseEntity {
	role: PageMetaType
	value: string
}

export interface PageNode extends BaseEntity {
	name: AvailablePageNodes
	order: number
	isWrappedContainer: boolean
	nodeParam: NodeParam[]
	pageMeta: PageMeta[]
}

export interface NodeParam extends BaseEntity {
	value: string
	componentType: AvailableComponentTypes
	pageNodeId: number
}

export interface Sitemap {
	url: string
	isRegional: boolean
	lastmod?: string
}

export interface PageNodeViewModel {
	value: PageNode
	children?: PageNodeViewModel[] | null
}

export interface TextRecord extends BaseEntity {
	key: string
	value: string
}

export interface PromoPage extends BaseEntity {
	id: number
	order: number
	title: string
	hexColor: string
	previewUrl: string
	url: string
}
